/** @format */
import { RefObject, useEffect, useRef, useState } from 'react';

export const useScroll = (
    ref: RefObject<HTMLElement | Window>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
    handler: (event: any) => void
) => {
    const dynamicHandler = useRef(handler);

    // Throttle scroll events to animation frames
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    let ticking = false;
    function listener(event: Event) {
        if (!ticking) {
            window.requestAnimationFrame(function () {
                dynamicHandler?.current?.(event);
                ticking = false;
            });
            ticking = true;
        }
    }

    useEffect(() => {
        dynamicHandler.current = handler;
    }, [handler]);

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions, @typescript-eslint/prefer-optional-chain -- Legacy code: do not use as an example.
        ref.current && ref.current.addEventListener('scroll', listener);

        return () => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions, @typescript-eslint/prefer-optional-chain, react-hooks/exhaustive-deps -- Legacy code: do not use as an example.
            ref.current && ref.current.removeEventListener('scroll', listener);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- Legacy code: do not use as an example.
    }, [ref.current]); // Recall only if ref changes
};

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum ScrollDirection {
    UP = 'up',
    DOWN = 'down',
    NONE = '',
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Legacy code: do not use as an example.
export interface ScrollState {
    x: number;
    y: number;
    direction: ScrollDirection;
}

export const useScrollInfo = () => {
    const [scroll, setScroll] = useState<ScrollState>({
        x: typeof window !== 'undefined' ? window.pageXOffset : 0,
        y: typeof window !== 'undefined' ? window.pageYOffset : 0,
        direction: ScrollDirection.NONE,
    });

    function listener(): void {
        setScroll((prev: ScrollState) => ({
            x: window.pageXOffset,
            y: window.pageYOffset,
            direction:
                prev.y > window.pageYOffset
                    ? ScrollDirection.UP
                    : ScrollDirection.DOWN,
        }));
    }

    useEffect(() => {
        window.addEventListener('scroll', listener);
        return () => window.removeEventListener('scroll', listener);
    }, []);

    return scroll;
};
